import { isEqual } from "lodash"
import * as React from "react"
import { Col, Form, Input, InputNumber, Row, Table } from "antd"
import { Link } from "../../../../server/router"
import { Color, Font, FontSize } from "../../../../constants"
import type { AutoCompleteSelectionItem } from "../components/AssignItemAutoComplete"
import AssignItemAutoComplete from "../components/AssignItemAutoComplete"
import type { ModifierGroupFormItemDisplayType, ModifierGroupModifierFormItem } from "./ModifierGroupForm"
import OverrideNotification from "../../../common/OverrideNotification"
import DragAndDropTableRowHover from "../../../common/dragAndDrop/DragAndDropTableRowHover"
import withDragAndDropContext from "../../../common/dragAndDrop/withDragAndDropContext"
import { numberToDollarsFormatter, numberToDollarsParser } from "../../../../utils/formatters"
import { AntdIconWrap } from "../../../uiKit/Icons/AntdIconWrap"
import { changeArrayItemPosition } from "../../../common/dragAndDrop/utils"
// import IndividualModifiersList from "./IndividualModifiersList"

type Props = {
    displaySelected: ModifierGroupFormItemDisplayType
    data: ModifierGroupModifierFormItem[]
    form: Record<string, any>
    modifiersAutocompleteSelection: AutoCompleteSelectionItem[]
    disabled?: boolean
    exclusion: boolean
    isNew: boolean
    onAnyFieldChange?: () => void
}
type State = {
    data: ModifierGroupModifierFormItem[]
    addModifierButtonClicked: boolean
}

class IndividualModifiersTable extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            data: this.props.data,
            addModifierButtonClicked: false,
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        if (!isEqual(this.props.data, nextProps.data)) {
            this.setState({
                data: nextProps.data,
            })
        }
    }

    assignOptionGroup = (groupId: string) => {
        const newModifierItem = this.props.modifiersAutocompleteSelection.find(p => p.id === groupId)

        if (!newModifierItem) {
            return
        }

        this.setState({
            data: [
                ...this.state.data,
                {
                    modifierId: newModifierItem.id,
                    groupItemId: null,
                    name: newModifierItem.title,
                    price: null,
                    groupExtra: null,
                    // @ts-expect-error
                    locationOverrides: [],
                    isActive: true,
                },
            ],
            addModifierButtonClicked: false,
        })
        this.props.onAnyFieldChange?.()
    }
    toggleAddModifierInput = () => {
        this.setState({
            addModifierButtonClicked: !this.state.addModifierButtonClicked,
        })
    }
    columns = [
        {
            title: "Modifiers",
            className: "first-column",
            dataIndex: "name",
            render: (text, record) => {
                return (
                    <div>
                        <Row
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                            }}>
                            <Col
                                span={3}
                                style={{
                                    height: "2rem",
                                    alignItems: "center",
                                    backgroundImage: "url(/dragHandler.svg)",
                                    backgroundPosition: "center center",
                                    backgroundRepeat: "no-repeat",
                                }}
                            />
                            <Col
                                span={21}
                                style={{
                                    paddingLeft: "1rem",
                                }}>
                                <Link href={`/menu/modifiers/edit/${record.modifierId}`}>
                                    <div
                                        style={{
                                            display: "inline-block",
                                        }}>
                                        {this.props.exclusion && (
                                            <span
                                                style={{
                                                    color: Color.Red,
                                                    marginRight: "3px",
                                                }}>
                                                No
                                            </span>
                                        )}
                                        <a className="route-to-modifier">{record.name}</a>
                                    </div>
                                </Link>
                                {!record.isActive && <span className="modifier-inactive">Inactive</span>}
                            </Col>
                        </Row>
                    </div>
                )
            },
        },
        {
            title: "Price",
            className: "align-right no-right-padding",
            render: (text, record, index) => {
                return (
                    <div>
                        <Form.Item
                            style={
                                record.priceOverriden === undefined || record.priceOverriden === null
                                    ? {}
                                    : {
                                          position: "relative",
                                          left: "13px",
                                      }
                            }>
                            {this.props.form.getFieldDecorator(`individual-modifier-price[${record.modifierId}]`, {
                                initialValue: record.price,
                            })(
                                <InputNumber
                                    style={{
                                        width: "4.5rem",
                                        textAlign: "right",
                                    }}
                                    onFocus={e => e.target.select()}
                                    step={0.01}
                                    formatter={numberToDollarsFormatter}
                                    parser={numberToDollarsParser}
                                />
                            )}
                            <OverrideNotification
                                style={{
                                    paddingLeft: "0.325rem",
                                }}
                                hidden={
                                    record.priceOverriden === undefined || record.priceOverriden === null
                                        ? true
                                        : !record.priceOverriden
                                }
                            />
                        </Form.Item>
                        <Form.Item>
                            {this.props.form.getFieldDecorator(`individual-modifier-id[${index}]`, {
                                initialValue: record.modifierId,
                            })(<Input type="hidden" />)}
                        </Form.Item>
                        <Form.Item>
                            {this.props.form.getFieldDecorator(`individual-modifier-group-item-id[${index}]`, {
                                initialValue: record.groupItemId,
                            })(<Input type="hidden" />)}
                        </Form.Item>
                    </div>
                )
            },
        },
        {
            title: "Group Extra",
            className: "align-right",
            render: (text, record) => {
                return (
                    <div>
                        <Form.Item>
                            {this.props.form.getFieldDecorator(
                                `individual-modifier-group-price[${record.modifierId}]`,
                                {
                                    initialValue: record.groupExtra,
                                    rules: [
                                        {
                                            required: false,
                                        },
                                    ],
                                }
                            )(
                                <InputNumber
                                    style={{
                                        width: "4.5rem",
                                        textAlign: "right",
                                    }}
                                    min={0}
                                    step={0.01}
                                    onFocus={e => {
                                        return e.target.select()
                                    }}
                                    onBlur={() => {
                                        const arrayOfModifierPrices = this.props.form.getFieldValue(
                                            "individual-modifier-group-price"
                                        )
                                        this.props.form.setFieldsValue({
                                            [`individual-modifier-group-price[${record.modifierId}]`]:
                                                arrayOfModifierPrices[record.modifierId],
                                        })
                                    }}
                                    formatter={numberToDollarsFormatter}
                                    parser={numberToDollarsParser}
                                />
                            )}
                            <OverrideNotification
                                style={{
                                    paddingLeft: "0.325rem",
                                }}
                                hidden={
                                    record.groupExtraOverriden === undefined || record.groupExtraOverriden === null
                                        ? true
                                        : !record.groupExtraOverriden
                                }
                            />
                        </Form.Item>
                    </div>
                )
            },
        },
        {
            title: "",
            width: "2%",
            className: "align-right",
            render: (text, record) => {
                if (this.props.disabled) {
                    return null
                }

                return (
                    <div>
                        <a href="" onClick={e => this.onDelete(e, record.modifierId)}>
                            <AntdIconWrap className="delete-icon" type="close" />
                        </a>
                    </div>
                )
            },
        },
    ]

    onHover = (sourceIndex: number, hoverIndex: number) => {
        this.setState(state => ({
            ...state,
            data: changeArrayItemPosition(state.data, sourceIndex, hoverIndex),
        }))
        this.props.onAnyFieldChange?.()
    }

    onDelete = (e, id) => {
        e.preventDefault()
        const dataSource = [...this.state.data]
        this.setState({
            data: dataSource.filter(item => item.modifierId !== id),
        })
        this.props.onAnyFieldChange?.()
    }
    renderAddOptionGroup = () => {
        if (!this.state.addModifierButtonClicked) {
            return (
                <button
                    type="button"
                    className={classes.addModifierButton}
                    onClick={this.toggleAddModifierInput}
                    onKeyPress={this.toggleAddModifierInput}>
                    <AntdIconWrap type="plus-circle" theme="filled" className={classes.plusIcon} />
                    Add Modifier
                </button>
            )
        } else if (this.state.addModifierButtonClicked) {
            const filteredSelection = this.props.modifiersAutocompleteSelection.filter(modifier => {
                return !this.state.data.find(d => d.modifierId === modifier.id)
            })
            return (
                <div className={classes.assignModifiersWrap}>
                    <AssignItemAutoComplete
                        addSelectionTitle="Create New Modifier"
                        createNewDisabled={this.props.isNew}
                        height="3rem"
                        handleSelected={this.assignOptionGroup}
                        handleClose={this.toggleAddModifierInput}
                        selections={filteredSelection}
                    />
                </div>
            )
        }

        return null
    }
    renderIndividualOptionsTable = () => {
        if (this.props.displaySelected === "scale") {
            return (
                <Table
                    style={{
                        marginBottom: "1.5rem",
                    }}
                    columns={this.columns}
                    // @ts-expect-error
                    cursor="move"
                    pagination={false}
                    dataSource={this.state.data}
                    components={{
                        body: {
                            row: DragAndDropTableRowHover,
                        },
                    }}
                    rowKey="_key"
                    footer={this.renderAddOptionGroup}
                    onRow={(record, index) => ({
                        id: record.modifierId,
                        parentId: null,
                        index: index,
                        onDropCallback: () => false,
                        onHoverCallback: this.onHover,
                    })}
                />
            )
        } else {
            return (
                <Table
                    style={{
                        marginBottom: "1.5rem",
                    }}
                    columns={this.columns}
                    pagination={false}
                    dataSource={this.state.data}
                    components={{
                        body: {
                            row: DragAndDropTableRowHover,
                        },
                    }}
                    rowKey="modifierId"
                    footer={this.renderAddOptionGroup}
                    onRow={(record, index) => ({
                        id: record.modifierId,
                        parentId: null,
                        index: index,
                        onDropCallback: () => false,
                        onHoverCallback: this.onHover,
                    })}
                />
            ) // return (
            //     <IndividualModifiersList
            //         form={this.props.form}
            //         data={this.state.data}/>
            // )
        }
    }

    render() {
        return (
            <div className="modifier-category-table-wrapper">
                <style jsx={true} global={true}>
                    {`
                        .modifier-category-table-wrapper {
                            margin-top: 2.5rem;
                            margin-bottom: 1.5rem;
                        }
                        .modifier-category-table-wrapper .ant-table {
                            border: 1px solid ${Color.antBorder};
                            cursor: move;
                        }
                        .modifier-category-table-wrapper .ant-form-item {
                            margin-bottom: 0;
                        }
                        .modifier-category-table-wrapper .ant-table-footer {
                            background-color: white;
                            padding: 0;
                        }
                        .modifier-category-table-wrapper .no-right-padding {
                            padding-right: 0;
                        }

                        .modifier-category-table-wrapper .delete-icon {
                            padding-right: 10px;
                            font-size: 1rem;
                            color: ${Color.Red};
                        }
                        .modifier-category-table-wrapper .active-switch {
                            padding-right: 7px;
                        }
                        .modifier-category-table-wrapper .first-column {
                            padding-left: 1.5rem;
                        }
                        .modifier-category-table-wrapper .ant-table-thead span {
                            font-weight: ${Font.Bold};
                            font-size: ${FontSize.sm};
                        }
                        .modifier-category-table-wrapper .modifier-inactive {
                            position: absolute;
                            top: 1rem;
                            left: 1rem;
                            font-size: 10px;
                            color: red;
                        }
                    `}
                </style>
                {this.renderIndividualOptionsTable()}
            </div>
        )
    }
}

const classes = {
    addModifierButton:
        "block bg-transparent w-full text-left text-primary-color cursor-pointer px-6 py-4 hover:bg-primary-color/5 transition-colors duration-200",
    plusIcon: "mr-2 text-[16px]",
    assignModifiersWrap: "m-2",
}

export default withDragAndDropContext(IndividualModifiersTable)
